/* eslint-disable import/no-cycle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Anchor } from '@mantine/core';
import AppStack from '../../../../../common/AppStack';
import AppText from '../../../../../common/AppText';
import WsFinalSaleWarningInfoModal from './WsFinalSaleWarningInfoModal';

const WsFinalSaleWarning = ({ config, isCheckout }) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  return (
    <AppStack style={{ gap: 0, alignItems: 'center' }}>
      {isCheckout ? (
        <AppText
          style={{
            fontSize: 14,
            color: '#FFF',
            textAlign: 'center',
            fontStyle: 'italic',
            fontWeight: 500
          }}
        >
          One or more products are marked as{' '}
          <Anchor
            onClick={() => setIsInfoModalOpen(true)}
            style={{
              fontSize: 14,
              textAlign: 'center',
              fontStyle: 'italic',
              fontWeight: 500
            }}
          >
            Final Sale
          </Anchor>
          .
        </AppText>
      ) : (
        <>
          <AppText
            style={{
              fontSize: 14,
              color: '#666',
              textAlign: 'center',
              fontStyle: 'italic',
              fontWeight: 500
            }}
          >
            This item is{' '}
            <Anchor
              onClick={() => setIsInfoModalOpen(true)}
              style={{
                fontSize: 14,
                textAlign: 'center',
                fontStyle: 'italic',
                fontWeight: 500
              }}
            >
              Final Sale
            </Anchor>{' '}
            and not eligible for return, exchange, or refund.
          </AppText>

          <Anchor
            onClick={() => setIsInfoModalOpen(true)}
            style={{ fontSize: 14, color: 'dodgerblue', fontStyle: 'italic' }}
          >
            Learn more.
          </Anchor>
        </>
      )}

      <WsFinalSaleWarningInfoModal
        isOpen={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
      />
    </AppStack>
  );
};

WsFinalSaleWarning.propTypes = {
  config: PropTypes.object,
  editModeEnabled: PropTypes.bool,
  isCheckout: PropTypes.bool,
  mediaQueries: PropTypes.object
};

export default WsFinalSaleWarning;
